<template>
  <div class="score-share">
    <div class="score-share__text-container">
      <img
        width="57"
        height="38"
        class="score-share__new"
        src="../assets/sparkles.png"
      />
      <p class="score-share__text">
        Think you're smarter than your friends?
      </p>
    </div>
    <button class="slate-button score-share__button" @click="share">
      {{ shareButtonText }}
    </button>
  </div>
</template>
<script>
import { pymChild } from "../utils.js";
export default {
  name: "ScoreShare",
  props: {
    score: { type: Number, required: true },
  },
  computed: {
    quizUrl() {
      return new URL(location.href).searchParams.get("parentUrl");
    },
  },
  data() {
    return {
      sharePayload: {},
      canShare: false,
      shareButtonText: "Share score",
    };
  },
  mounted() {
    this.generateSharePayload();
  },
  methods: {
    generateSharePayload() {
      this.sharePayload = {
        title: `Slate`,
        text: `I scored ${this.score} in today's Slate Quiz. Think you can beat me?`,
        url: this.quizUrl,
      };
      this.canShare =
        navigator.canShare && navigator.canShare(this.sharePayload);
    },
    share() {
      try {
        // If the browser supports the Web Share API use it
        // if not, fallback to copying the message and url to the clipboard
        if (this.canShare) {
          navigator.share(this.sharePayload);
        } else {
          pymChild.sendMessage(
            "copy",
            JSON.stringify({
              text: `${this.sharePayload.text} - ${this.sharePayload.url}`,
            })
          );
          this.shareButtonText = "Copied to clipboard!";
        }

        const amplitudeData = {
          eventName: "Quiz - Share Score",
        };
        pymChild.sendMessage("tracking", JSON.stringify(amplitudeData));
      } catch (error) {
        console.error("Error sharing: ", error);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.score-share {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-radius: 3px;
  background-color: #{"hsla(var(--txt-color-hsl), 0.065)"};
  min-height: 65px;
  padding: 1em;
  margin: 1em 0 0;
  @media (max-width: 35em) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

.score-share__text-container {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0.5em;
  @media (max-width: 35em) {
    flex-direction: column;
    gap: 0;
  }
}

.score-share__new {
  height: 2em;
  @media (max-width: 35em) {
    height: 1.5em;
  }
}

.score-share__text {
  margin: 0.5em 0 0.5em 0;
  @media (max-width: 35em) {
    text-align: center;
  }
}
.score-share__button {
  background-color: #e60d48; // cherry-dark-10
  margin-left: 1em;
  @media (max-width: 35em) {
    margin-left: 0;
  }
}
</style>
